import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VueMarkdown from 'vue-markdown';
import Loading from '@/components/Loading.vue';
import ImageWithLoading from '@/components/ImageWithLoading.vue';
import CharactersSpeciesDetailHalfHuman from './CharactersSpeciesDetailHalfHuman.vue';
import BackButton from '@/components/BackButton.vue';
const speciesModule = namespace('species');
let CharactersSpeciesDetail = class CharactersSpeciesDetail extends Vue {
    created() {
        this.fetchSpecies();
    }
    get title() {
        return this.$router.currentRoute.path.includes('phb')
            ? this.speciesName + ' | Handbook' + Vue.prototype.$titleSuffix
            : this.speciesName + Vue.prototype.$titleSuffix;
    }
    get speciesData() {
        return this.species.find(({ name }) => name === this.speciesName);
    }
};
__decorate([
    speciesModule.State
], CharactersSpeciesDetail.prototype, "species", void 0);
__decorate([
    speciesModule.Action
], CharactersSpeciesDetail.prototype, "fetchSpecies", void 0);
__decorate([
    Prop(String)
], CharactersSpeciesDetail.prototype, "speciesName", void 0);
__decorate([
    Prop(Boolean)
], CharactersSpeciesDetail.prototype, "isHidingBack", void 0);
CharactersSpeciesDetail = __decorate([
    Component({
        components: {
            CharactersSpeciesDetailHalfHuman,
            VueMarkdown,
            Loading,
            BackButton,
            ImageWithLoading
        }
    })
], CharactersSpeciesDetail);
export default CharactersSpeciesDetail;
